/* Customer comments of the news page: opens the comment box, grows it while typing, and makes Like / Reply work. */
(function () {
  function setup(root) {
    if (root.__advReady) return;
    root.__advReady = true;
    var form = root.querySelector('.adv-cm__form');
    var box = form && form.querySelector('textarea');

    function open() {
      if (form) form.classList.add('is-open');
    }

    if (box) {
      box.addEventListener('focus', open);
      box.addEventListener('input', function () {
        open();
        box.style.height = 'auto';
        box.style.height = box.scrollHeight + 2 + 'px';
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cm-act]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('data-cm-act') === 'like') {
        btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        return;
      }
      if (!box) return;
      open();
      var who = btn.getAttribute('data-name');
      if (who && !box.value) box.value = '@' + who + ' ';
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.focus();
      box.setSelectionRange(box.value.length, box.value.length);
    });
  }

  function init() {
    var list = document.querySelectorAll('[data-adv-comments]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();